<template>
  <vxe-modal
    ref="modal"
    v-model="formVisible"
    :title="`${DocumentStatus}汇款申请单`"
    width="80%"
    height="90%"
    @show="showModal"
  >
    <div class="formContainer">
      <div class="leftFormContainer">
        <el-form ref="FormRef" size="mini" :rules="rules" :model="form" :disabled="isDisabled">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="申请日期" prop="apply_date">
                <el-date-picker
                  type="date"
                  placeholder="输入"
                  value-format="yyyy-MM-dd"
                  v-model="form.apply_date"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="申请人" prop="users_name">
                <!-- <el-input placeholder="关联" v-model="form.users_name" v-readonly> </el-input> -->
                <el-input
                  placeholder="选择"
                  v-model="form.users_name"
                  v-readonly
                  :clearable="$store.state.userInfo.authority.includes('财务审核')"
                >
                  <i
                    style="cursor: pointer;"
                    v-if="$store.state.userInfo.authority.includes('财务审核')"
                    slot="suffix"
                    class="el-icon-search"
                    @click="handleSelect"
                  ></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收款人名称" prop="payee">
                <!-- <el-input placeholder="输入" v-model="form.payee" /> -->
                <el-autocomplete
                  v-model="form.payee"
                  :fetch-suggestions="querySearchPayee"
                  placeholder="输入"
                  clearable
                ></el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="开户行及账号" prop="bank_account">
                <!-- <el-input placeholder="输入" v-model="form.bank_account" /> -->
                <el-autocomplete
                  v-model="form.bank_account"
                  :fetch-suggestions="querySearchAccount"
                  placeholder="输入"
                  clearable
                ></el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="金额" prop="amout">
                <el-input placeholder="输入" v-model="form.amout" v-money:2="showMoney" />
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="大写金额">
                <el-input placeholder="自动计算" v-readonly :value="convertCurrency(form.amout)" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="汇出日期" prop="remittance_date">
                <el-date-picker
                  type="date"
                  placeholder="输入"
                  value-format="yyyy-MM-dd"
                  v-model="form.remittance_date"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="汇出公司" prop="remittance_company">
                <!-- <el-input placeholder="输入" v-model="form.remittance_company" /> -->
                <el-select clearable v-model="form.remittance_company" placeholder="选择">
                  <el-option
                    v-for="i of ComBoxItems.company"
                    :key="i.name + ''"
                    :label="i.name"
                    :value="i.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="汇款事由" prop="subject_matter">
                <el-input type="textarea" :rows="5" placeholder="输入" v-model="form.subject_matter" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="备注" prop="memo">
                <el-input type="textarea" :rows="5" placeholder="输入" v-model="form.memo" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="rightFormContainer">
        <FileList :ID="id" :isDisabled="isDisabled" ref="FileListRef" vuePath="Remittance" />
      </div>
    </div>

    <DetailModalBtnVue
      ref="DetailModalBtnVueRef"
      menuPath="Remittance"
      :parentData="this"
      @handleClick="handleClickBtn"
    />

    <!-- 选择用户 -->
    <EmployeeSelect ref="EmployeeSelectRef" :isMultiple="false" @sureBackPerson="sureBackPerson" />
  </vxe-modal>
</template>
<script>
import FileList from '@/components/Form/FileList.vue'
import DetailModalBtnVue from '@/components/common/DetailModalBtn.vue'
import EmployeeSelect from '../../components/Modal/Employee/EmployeeSelect.vue'
import { getState } from '../../utils/state'
import { handlePrint } from './print'

export default {
  components: {
    FileList,
    DetailModalBtnVue,
    EmployeeSelect
  },
  data() {
    return {
      id: -1,
      // 表单
      form: {
        id: '',
        users_name: '',
        creator_id: '',
        creator: '',
        createTime: '',
        document_status: 0,
        cmbDocument_status: '',
        apply_date: '',
        users_id: '',
        payee: '',
        bank_account: '',
        amout: '',
        subject_matter: '',
        remittance_company: '',
        remittance_date: '',
        memo: '',
        last_modify_time: ''
      },
      rules: {
        apply_date: [{ required: true, message: '请输入申请日期', trigger: 'change' }],
        users_name: [{ required: true, message: '请选择申请人', trigger: 'change' }],
        payee: [
          { required: true, message: '请输入收款人名称', trigger: 'change' },
          {
            min: 0,
            max: 256,
            message: '长度在 0 到 256 个字符',
            trigger: 'change'
          }
        ],
        bank_account: [
          { required: true, message: '请输入开户行及账号', trigger: 'change' },
          {
            min: 0,
            max: 256,
            message: '长度在 0 到 256 个字符',
            trigger: 'change'
          }
        ],
        amout: [
          { required: true, message: '请输入金额', trigger: 'change' },
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.greaterThanZero,
            length: 12,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        remittance_date: [{ required: true, message: '请输入汇出日期', trigger: 'change' }],
        remittance_company: [
          { required: true, message: '请输入汇出公司', trigger: 'change' },
          {
            min: 0,
            max: 256,
            message: '长度在 0 到 256 个字符',
            trigger: 'change'
          }
        ],
        subject_matter: [
          { required: true, message: '请输入汇出事由', trigger: 'change' },
          {
            min: 0,
            max: 256,
            message: '长度在 0 到 256 个字符',
            trigger: 'change'
          }
        ],
        memo: [
          {
            min: 0,
            max: 512,
            message: '长度在 0 到 512 个字符',
            trigger: 'change'
          }
        ]
      },
      // 下拉框
      ComBoxItems: {
        company: [
          {
            name: '福州远控',
            value: '福州远控'
          },
          {
            name: '福建远控',
            value: '福建远控'
          },
          {
            name: '中心',
            value: '中心'
          },
          {
            name: '公司',
            value: '公司'
          }
        ]
      },
      formVisible: false,

      showMoney: true,
      // 是否禁用编辑
      isDisabled: false,
      // 快速输入
      quickSelectPayee: [],
      quickSelectAccount: []
    }
  },
  methods: {
    handlePrint,
    // 获取下拉框
    async handleGetSelectItem() {
      const { data: res } = await this.$http.get('/finance/funds_transfers_application/select-item')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.quickSelectPayee = res.data.filter(item => item.code === 'payee')
      this.quickSelectAccount = res.data.filter(item => item.code !== 'payee')
    },
    querySearchAccount(queryString, cb) {
      const quickSelectAccount = this.form.payee
        ? this.quickSelectAccount.filter(item => item.code === this.form.payee)
        : this.quickSelectAccount

      const results = queryString
        ? quickSelectAccount.filter(item => String(item.value).includes(queryString))
        : quickSelectAccount
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    querySearchPayee(queryString, cb) {
      const quickSelectPayee = this.quickSelectPayee
      const results = queryString
        ? quickSelectPayee.filter(item => String(item.value).includes(queryString))
        : quickSelectPayee
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    // 获取附件
    getFileList() {
      this.$refs.FileListRef.init()
    },
    // 拒绝
    refuse() {
      this.$confirm('是否确认拒绝?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureObsolete()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 领导/总经理审批
    leaderReview() {
      this.$confirm('是否确认审批通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 取消审核
    unReview() {
      this.$confirm('是否确认取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 调用审批接口
    async sureReview(flag = false) {
      const { data: res } = await this.$http.put('/finance/funds_transfers_application/audit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用撤销审核
    async sureUnReview(flag = false) {
      const { data: res } = await this.$http.put('/finance/funds_transfers_application/unaudit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用拒绝接口
    async sureObsolete() {
      const { data: res } = await this.$http.put('/finance/funds_transfers_application/obsolete', [
        {
          id: this.id,
          manager_review: false
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 点击底部按钮
    handleClickBtn(code) {
      switch (code) {
        case 'save':
          this.save()
          break
        case 'del':
          this.del()
          break
        case 'unReview':
          this.unReview()
          break
        case 'managerReview':
        case 'leaderReview':
          this.leaderReview()
          break
        case 'refuse':
          this.refuse()
          break
        case 'close':
          this.formVisible = false
          break
        case 'printPreview':
          this.handlePrint(this.form)
          break
      }
    },
    // 打开模态窗
    openModal(id = 0) {
      this.id = id

      if (!this.id) {
        this.form = {
          id: '',
          users_name: '',
          creator_id: '',
          creator: '',
          createTime: '',
          document_status: 0,
          cmbDocument_status: '',
          apply_date: '',
          users_id: '',
          payee: '',
          bank_account: '',
          amout: '',
          subject_matter: '',
          remittance_company: '',
          remittance_date: '',
          memo: '',
          last_modify_time: ''
        }
      }

      this.$nextTick(() => {
        this.formVisible = true
      })
    },
    async validEnter() {
      const that = this
      let flag = true
      await that.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )

      if (!flag) {
        that.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 保存
    save() {
      this.validEnter().then(async result => {
        if (result) {
          if (this.id && this.id > 0) {
            this.update()
          } else {
            this.add()
          }
        }
      })
    },
    // 获取数据
    async BindText() {
      const that = this
      if (that.id > 0) {
        const { data: res } = await that.$http.get('/finance/funds_transfers_application', {
          params: {
            id: that.id
          }
        })
        if (res.isSuccess) {
          that.form = res.data
        }
      } else {
        this.form.apply_date = this.ykDateFormat('yyyy-MM-dd', new Date())
        // 用户信息赋值
        this.form.users_id = this.$store.state.userInfo.userId
        this.form.users_name = this.$store.state.userInfo.name

        this.form.creator_id = this.$store.state.userInfo.userId
        this.form.creator = this.$store.state.userInfo.name
        this.form.createTime = this.ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date())
      }
      that.$nextTick(() => {
        that.$refs.FormRef.clearValidate()

        console.log(this.form.creator_id)
        if (this.form.document_status !== 0 || this.form.creator_id !== this.$store.state.userInfo.userId) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      })
    },
    // 新增
    async add() {
      const that = this
      let form = { ...that.form }
      form = that.removeObjectNull(form)
      const { data: res } = await that.$http.post('/finance/funds_transfers_application', form)
      if (res.isSuccess) {
        that.id = res.data
        that.$emit('updateData')

        this.$refs.FileListRef.handleUploadCacheFileToDB() // 提交缓存附件

        that.BindText()
        that.$message.success(that.messageConfig.save.success)
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    // 更新
    async update() {
      const that = this
      let form = { ...that.form }
      form = that.removeObjectNull(form)
      const { data: res } = await that.$http.put('/finance/funds_transfers_application', form)
      if (res.isSuccess) {
        that.$message.success(that.messageConfig.save.success)
        that.$emit('updateData')

        that.BindText()
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    // 删除
    del() {
      const that = this
      this.$confirm('此操作将永久删除该单据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await that.$http.delete('/finance/funds_transfers_application', {
          data: {
            id: that.id
          }
        })
        if (res.isSuccess) {
          that.$message.success(that.messageConfig.del.success)
          that.formVisible = false

          that.$emit('updateData')
        } else {
          that.$message.error(res.errorMessage)
        }
      })
    },
    // 提交缓存文件
    submitCacheFileToServer() {
      // this.$refs.FileListRef.handleUploadCacheFileToDB()
    },
    // 大写金额转换
    convertCurrency(amount) {
      if (amount == null || amount == '') {
        return ''
      }
      return this.amountLtoU(amount)
    },
    async showModal() {
      await this.BindText()

      this.handleGetSelectItem()

      this.getFileList()
    },
    // 选择人员
    handleSelect() {
      if (!this.isDisabled) {
        this.$refs.EmployeeSelectRef.openModal(this.form.users_name)
      }
    },
    // 选择完成后
    sureBackPerson(person) {
      this.form.users_name = person
    }
  },
  computed: {
    // 获取状态
    DocumentStatus() {
      if (this.id === 0) {
        return ''
      }

      return `[${getState(this.form, 'Remittance')}] `
    }
  }
}
</script>
<style lang="less" scoped>
@rightFormContainerWidth: 250px;

.bottomBtns {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.formContainer {
  height: calc(100% - 40px - 10px - 31px);
  display: flex;
  flex-wrap: wrap;
}
.el-form-item {
  // margin: 0px !important;
  width: 100%;
  .el-input,
  .el-select,
  .el-date-picker {
    width: 100%;
  }
}
.leftFormContainer {
  width: calc(100% - @rightFormContainerWidth);
  height: 100%;

  box-sizing: border-box;
  padding: 0 10px 10px 10px;

  overflow: auto;

  /* 修改滚动条的宽度和颜色 */
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #999;
  }

  /* 鼠标悬停时滚动条 thumb 的颜色 */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #888;
  }
}
.rightFormContainer {
  height: 100%;
  width: @rightFormContainerWidth;
  box-sizing: border-box;
  padding: 0 10px;
}
.el-autocomplete {
  width: 100%;
}
</style>
